import { render, staticRenderFns } from "./menuTemplate.vue?vue&type=template&id=1a337cec&scoped=true&"
import script from "./menuTemplate.vue?vue&type=script&lang=js&"
export * from "./menuTemplate.vue?vue&type=script&lang=js&"
import style0 from "./menuTemplate.vue?vue&type=style&index=0&id=1a337cec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a337cec",
  null
  
)

export default component.exports